import { Text } from "../Text";
import { Line, LineTextWrapper } from "./style";
import { DividerProps } from "./types";
import spacing from "theme/spacing.module.scss";

export const Divider = ({ text, color, smallMargin = false, ...props }: DividerProps) => {
    return(
      <LineTextWrapper $hasText={!!text} $smallMargin={smallMargin && spacing.spacingXXS} {...props}>
          <Line $color={color} />
        {text && (
          <Text $textVariant="label" $textColor="text500">
            {text}
          </Text>
        )}
          <Line $color={color} />
      </LineTextWrapper>
    );
}
